export default "__VITE_ASSET__C93p0a4e__"